import CSRF from 'csrf'

document.addEventListener('DOMContentLoaded', () => {
  const buttonCancel = document.getElementById('js-cancel-status-started')
  if (!buttonCancel) {
    return null
  }

  buttonCancel.addEventListener('click', () => {
    const permitCancel = confirm('進捗状況を未着手に戻しますか？')
    if (!permitCancel) {
      return null
    }

    const params = new FormData()
    params.append('status', 'unstarted')

    const practiceId = buttonCancel.getAttribute('data-practice-id')
    fetch(`/api/practices/${practiceId}/learning.json`, {
      method: 'PATCH',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': CSRF.getToken()
      },
      credentials: 'same-origin',
      redirect: 'manual',
      body: params
    })
    .then((response) => {
      if(response.ok) {
        window.location.reload();
      }
      else{
        response.json().then((data) => {
          alert(data.error)
        })
      }
    })
    .catch((error) => {
      console.warn(error)
    })
  })
})